import PageHeader from "@/components/PageHeader";
import LegalLayout from "@/components/LegalLayout";
import { useDocumentSEO } from "@/hooks/useDocumentSEO";

export default function KvkkPage() {
  useDocumentSEO({
    title: "KVKK Aydınlatma Metni",
    description:
      "1001 Mimarlık İnşaat ve Ticaret A.Ş. — Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında iletişim formu verilerinin işlenmesine ilişkin aydınlatma metni.",
  });
  return (
    <>
      <PageHeader
        breadcrumb="KVKK Aydınlatma Metni"
        overline="Yasal Bilgilendirme"
        title="Kişisel Verilerin Korunması Hakkında Aydınlatma Metni"
      />
      <LegalLayout>
        <p>
          İşbu Aydınlatma Metni; 6698 sayılı Kişisel Verilerin Korunması
          Kanunu&apos;nun (&quot;KVKK&quot;) 10. maddesi kapsamında, veri
          sorumlusu sıfatıyla{" "}
          <strong>1001 Mimarlık İnşaat ve Ticaret A.Ş.</strong> tarafından,
          web sitemiz üzerinden iletilen talepler nedeniyle işlenen kişisel
          verilerinize ilişkin sizleri bilgilendirmek amacıyla hazırlanmıştır.
        </p>

        <h2>1. Veri Sorumlusu</h2>
        <p>
          1001 Mimarlık İnşaat ve Ticaret A.Ş., KVKK uyarınca &quot;veri
          sorumlusu&quot; sıfatını haizdir. Bu metin çerçevesinde toplanan
          kişisel veriler, aşağıda belirtilen amaç ve kapsamda işlenmektedir.
        </p>

        <h2>2. İşlenen Kişisel Veriler</h2>
        <p>
          Web sitemizde yer alan &quot;Teklif Talebi&quot; ve &quot;İş
          Birliği&quot; formları aracılığıyla; ad-soyad, telefon numarası,
          e-posta adresi, kurum/şirket adı ve talebinize/mesajınıza ilişkin
          serbest metin verileriniz tarafımızca toplanmaktadır.
        </p>

        <h2>3. Kişisel Verilerin İşlenme Amaçları</h2>
        <p>Toplanan kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:</p>
        <ul>
          <li>
            Tarafınızca iletilen teklif talebinin değerlendirilmesi ve
            uygun görülmesi hâlinde geri dönüş sağlanması,
          </li>
          <li>
            İş birliği taleplerinin ilgili birimlerce incelenmesi ve iş
            geliştirme süreçlerinin yürütülmesi,
          </li>
          <li>Sizinle e-posta veya telefon aracılığıyla iletişime geçilmesi,</li>
          <li>
            Sözleşme süreçleri, muhasebe, hukuki uyum ve kurumsal kayıt
            tutma yükümlülüklerinin yerine getirilmesi,
          </li>
          <li>
            Yasal düzenlemelerden doğan yükümlülüklerin ifası ve talep
            hâlinde yetkili kamu kurum ve kuruluşlarına bilgi verilmesi.
          </li>
        </ul>

        <h2>4. Kişisel Verilerin Aktarılması</h2>
        <p>
          Kişisel verileriniz; yalnızca yukarıda belirtilen amaçlarla
          sınırlı olmak üzere, yasal zorunluluklar çerçevesinde yetkili
          kamu kurum ve kuruluşlarına, hizmet aldığımız iş ortaklarımıza
          ve tedarikçilerimize KVKK&apos;nın 8. ve 9. maddelerinde
          düzenlenen şartlara uygun olarak aktarılabilir. Kişisel
          verileriniz reklam ve pazarlama amacıyla üçüncü kişilere
          satılmaz veya devredilmez.
        </p>

        <h2>5. Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebebi</h2>
        <p>
          Kişisel verileriniz; web sitemizdeki iletişim formlarını
          doldurmanız yoluyla elektronik ortamda, açık rızanız ve/veya
          KVKK&apos;nın 5. maddesinde belirtilen &quot;bir sözleşmenin
          kurulması veya ifasıyla doğrudan ilgili olması&quot;,
          &quot;veri sorumlusunun meşru menfaati&quot; ve &quot;hukuki
          yükümlülüğün yerine getirilmesi&quot; hukuki sebeplerine
          dayanılarak işlenmektedir.
        </p>

        <h2>6. KVKK&apos;nın 11. Maddesi Kapsamındaki Haklarınız</h2>
        <p>
          KVKK&apos;nın 11. maddesi uyarınca her zaman veri sorumlusuna
          başvurarak;
        </p>
        <ul>
          <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme,</li>
          <li>
            İşlenmişse buna ilişkin bilgi ve işlenme amacına uygun kullanılıp
            kullanılmadığını öğrenme,
          </li>
          <li>
            Yurt içinde veya yurt dışında verilerin aktarıldığı üçüncü kişileri
            bilme,
          </li>
          <li>
            Eksik veya yanlış işlenmiş olması hâlinde düzeltilmesini isteme,
          </li>
          <li>
            KVKK ve ilgili mevzuatta öngörülen şartlar çerçevesinde silinmesini
            veya yok edilmesini isteme,
          </li>
          <li>
            Yapılan işlemlerin, kişisel verilerinizin aktarıldığı üçüncü
            kişilere bildirilmesini isteme,
          </li>
          <li>
            İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz
            edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz
            etme,
          </li>
          <li>
            Kanuna aykırı işleme sebebiyle zarara uğramanız hâlinde zararın
            giderilmesini talep etme
          </li>
        </ul>
        <p>haklarına sahipsiniz.</p>

        <h2>7. Başvuru Yöntemi</h2>
        <p>
          KVKK&apos;nın 11. maddesi kapsamındaki taleplerinizi; kimliğinizi
          tespit edici belgeler ve talep konusunu içeren bir başvuru ile
          aşağıdaki iletişim kanallarımız üzerinden tarafımıza
          iletebilirsiniz:
        </p>
        <ul>
          <li>
            <strong>E-posta:</strong>{" "}
            <a href="mailto:info@1001insaat.com.tr">info@1001insaat.com.tr</a>
          </li>
          <li>
            <strong>Adres:</strong> Eyüp Sultan, İmam Rabbani Cd. No:34/B,
            34885 Sancaktepe / İstanbul
          </li>
        </ul>
        <p>
          Talebiniz, niteliğine göre en kısa sürede ve her hâlükârda KVKK
          madde 13/2&apos;de belirtilen otuz (30) günlük süre içinde
          değerlendirilerek sonuçlandırılacaktır.
        </p>

        <p className="legal-note">
          Not: İşbu metin genel bir aydınlatma taslağı niteliğinde olup,
          şirketinizin özel süreçleri ve mevzuat değişiklikleri göz önünde
          bulundurularak bir hukuk danışmanı tarafından gözden geçirilmesi
          önerilir.
        </p>
      </LegalLayout>
    </>
  );
}
